export default "__VITE_ASSET__CeyggmoL__"